<div class="mb-4 d-flex-between">
  <div class="d-grid">
    <h3 class="mb-0">{{ "medical-advice.list-page-title" | translate }}</h3>
    <p>{{ "medical-advice.list-page-description" | translate }}</p>
  </div>
  <div class="d-flex align-items-center">
    <a class="btn btn-warning ms-2" (click)="filterCollaps = !filterCollaps">
      {{ "general.filter" | translate }}
    </a>
    <button type="button" class="btn btn-primary ms-2" (click)="initilize()">
      {{ "medical-advice.add-button" | translate }}
    </button>
  </div>
</div>

<div class="row mt-3">
  <div class="filter cm-content-box box-primary" *ngIf="filterCollaps">
    <div class="content-title">
      <div class="cpa">
        <i class="fa-sharp fa-solid fa-filter me-2"></i
        >{{ "general.filter" | translate }}
      </div>
      <div class="tools">
        <a (click)="filterCollaps = false" class="btn btn-default btn-icon-md"
          ><i class="fa fa-close"></i
        ></a>
      </div>
    </div>

    <div class="cm-content-body form excerpt">
      <div class="card-body">
        <div class="row">
          <div class="col-xl-3 col-sm-6">
            <label for="">{{ "medical-advice.search" | translate }}</label>
            <input
              type="search"
              class="form-control mb-xl-0 mb-3"
              [placeholder]="'medical-advice.search-placeholder' | translate"
              aria-controls="user-tbl"
              [(ngModel)]="filter.search"
            />
          </div>

          <div class="col-xl-3 col-sm-6">
            <label for="">{{ "medical-advice.call-phone-label" | translate }}</label>
            <input
              type="search"
              class="form-control mb-xl-0 mb-3"
              [placeholder]="
                'medical-advice.call-phone-search-placeholder' | translate
              "
              aria-controls="user-tbl"
              [(ngModel)]="filter.callPhone"
            />
          </div>
          <div class="col-xl-3 col-sm-6">
            <label for="">{{ "medical-advice.call-reason" | translate }}</label>
            <p-dropdown
              [options]="callReasons"
              [showClear]="true"
              [placeholder]="'medical-advice.call-reason-select' | translate"
              [(ngModel)]="filter.callReason"
            >
            </p-dropdown>
          </div>
          <div class="col-xl-3 col-sm-6 mb-3">
            <label for="">{{ "medical-advice.date" | translate }}</label>
            <p-calendar
              [(ngModel)]="filter.date"
              [placeholder]="'medical-advice.date-placeholder' | translate"
              [showTime]="false"
              [showButtonBar]="true"
              appendTo="body"
              #filterDate
            />
          </div>
          <div class="col-12 d-flex justify-content-end mt-3">
            <button
              class="btn btn-danger light"
              (click)="clearFilter()"
              type="button"
            >
              {{ "general.clear-filter" | translate }}
            </button>
            <button
              class="btn btn-info ms-2"
              type="button"
              (click)="getList({})"
            >
              {{ "general.filtering" | translate }}
              <i class="fa fa-search ms-2"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card">
    <div class="card-body p-0">
      <div class="table-responsive active-projects style-1">
        <div class="tbl-caption">
          <h4 class="heading mb-0">
            {{ "medical-advice.list-table-name" | translate }}
          </h4>
        </div>
        <p-table
          [rowHover]="true"
          responsiveLayout="stack"
          [rows]="rows"
          [first]="first"
          [totalRecords]="totalRecords"
          [lazy]="true"
          (onLazyLoad)="getList($event)"
          paginatorDropdownAppendTo="body"
          [value]="items"
          [paginator]="true"
          [rowsPerPageOptions]="[10, 20, 30]"
        >
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="id" scope="col">
                <span class="p-column-title"
                  >{{ "common.id" | translate }} <p-sortIcon field="id"
                /></span>
              </th>
              <th pSortableColumn="personNo" scope="col">
                <span class="p-column-title">
                  {{ "medical-advice.personNo" | translate }}
                  <p-sortIcon field="personNo"
                /></span>
              </th>
              <th pSortableColumn="personFullName" scope="col">
                <span class="p-column-title">
                  {{ "medical-advice.patient-fullname" | translate }}
                  <p-sortIcon field="personFullName"
                /></span>
              </th>
              <th pSortableColumn="createdAt" scope="col">
                <span class="p-column-title">
                  {{ "medical-advice.createdAt" | translate }}
                  <p-sortIcon field="createdAt"
                /></span>
              </th>
              <th pSortableColumn="callReason" scope="col">
                <span class="p-column-title">
                  {{ "medical-advice.callReason" | translate }}
                  <p-sortIcon field="callReason"
                /></span>
              </th>
              <th pSortableColumn="userNote" scope="col">
                <span class="p-column-title">
                  {{ "medical-advice.user-note" | translate }}
                  <p-sortIcon field="userNote"
                /></span>
              </th>
              <th scope="col"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-list>
            <tr>
              <td>{{ list?.id }}</td>
              <td>{{ list?.personNo?.id }}</td>
              <td>
                {{ list?.personFullName ?? '' }} 
              </td>

              <td>
                {{ list?.createdAt | dateFormat : true }}
              </td>
              <td>
                {{
                  list?.callReason?.valueObject?.name.value | textLimiter : 50
                }}
              </td>

              <td>{{ list?.userNote | textLimiter : 60 }}</td>

              <td>
                <i class="pi pi-pencil edit-history-action-icon" (click)="initilize(list)"></i>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="paginatorleft">
            {{ totalRecords }} {{ "common.table.totalFound" | translate }}
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="99">{{ "common.noData" | translate }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>

<core-medical-advice-dialog
  #medicalAdviceDialog
  (saveOn)="onCreatedNewItem($event)"
  (updateOn)="onUpdatedNewItem($event)"
/>
